import { render } from "./MoveBlockComponent.vue?vue&type=template&id=1352c0b8&scoped=true"
import script from "./MoveBlockComponent.vue?vue&type=script&lang=js"
export * from "./MoveBlockComponent.vue?vue&type=script&lang=js"

import "./MoveBlockComponent.vue?vue&type=style&index=0&id=1352c0b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1352c0b8"

export default script